/*
*###############################################################################
*Module Name                   : TemplateMaster.js                              #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Friday, September 16th 2021, 09:49:55 am      #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect, useContext } from 'react'
import { MetaTags } from 'react-meta-tags'
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    Alert,
} from 'reactstrap'

//**Importing required componant files   */
import Breadcrumb from 'components/Common/Breadcrumb'
import DPTopToolBar from 'framework/widgets/DPTopToolBar'

import { Text } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import DPPermission from "framework/widgets/DPPermission"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';


const moment = require('moment');

import DPPrintOption from 'framework/widgets/DPPrintOptions'

import { ExecuteSPStructure, GetSPDropdown, GetSPStructure } from './DynamicUIFromSPControlller'
import { DynamicUIFromSPContent } from './DynamicUIFromSPContent'


//**End Importing required componant files */

const DynamicUIFromSP = (props) => {

    let history = useHistory();

    //*** User input related states */

    const [menuCode, SetMenuCode] = useState("")
    const [parameters, setParameters] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [spDropdownList, setSpDropdownList] = useState([])
    const [selectedDropdown, setSelectedDropdown] = useState("")
    const [keepSelectedSP, setKeepSelectedSP] = useState(false)


    //*** End User input related states */

    //*** User Activity related states*/
    const [show, setShow] = useState(false)
    const [AlertMsg, setAlertMsg] = useState('')
    const [AlertColor, setAlertColor] = useState('')

    const [saveEnable, setSaveEnable] = useState(true)
    const [deleteEnable, SetDeleteEnable] = useState(false)
    const [editEnable, SetEditEnable] = useState(false)
    const [Reason, setReason] = useState("Created")

    //*** End User activity related staes */

    //Alert Parameter
    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)
    const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
    const [ErrorMsg, setErrorMsg] = useState('')
    const [addNew, SetAddNew] = useState(true)
    //*****Menu Rights Start*/
    const [menuAccess, SetMenuAccess] = useState(false)
    const [menuCreate, SetMenuCreate] = useState(false)
    const [menuDelete, SetMenuDelete] = useState(false)
    const [menuModify, SetMenuModify] = useState(false)
    const [menuPrint, SetMenuPrint] = useState(false)
    const [menuProcess, SetMenuProcess] = useState(false)
    const [menuName, SetMenuName] = useState("")
    const [parentName, SetParentName] = useState("")

    const [LocationCode, setLocationCode] = useState("")
    const [locationName, setLocationName] = useState("")
    const [LogUserType, setLogUserType] = useState("")
    const [LogCompanyCode, setLogCompanyCode] = useState("")
    //*****Menu Rights End */

    /**********Loading Alert */
    const [loadingAlert, SetLoadingAlert] = useState(false)
    const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
    /**********End Loading Alert */

    //autocode generation related newly added code

    const [nullCode, setNullCode] = useState(false)
    const [autoCode, setAutoCode] = useState(false)

    //User Permission related usestates
    const [permissionAlertShow, setPermissionAlertShow] = useState(false)
    const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
    const [permissionReasonShow, setPermissionReasonShow] = useState(true)
    const [permissionName, setPermissionName] = useState("")
    const [permissionPassword, setPermissionPassword] = useState("")
    const [permissionNameDisable, setPermissionNameDisable] = useState(false)

    const [printoptionShow, setprintoptionShow] = useState(false)

    var time = process.env.REACT_APP_ALERTTIMEOUT
    const ApiURL = window.Links.ApiURL

    //const [ws, setWs] = useState(new WebSocket(`${socketURl}api/WebSocket/ws`));


    //**Permission Granted Alert usestates */
    const [editCheck, setEditCheck] = useState(false)
    const [permissionGrantedAlertShow, setPermissionGrantedAlertShow] = useState(false)
    const [permissionGrantedAlertMsg, setPermissionGrantedAlertMsg] = useState("")
    const [permissionGrantedAlertColor, setPermissionGrantedAlertColor] = useState("")

    //import from contexts
    const {
        isHeadOffice, getMenuDetails, masterAuditLog, getSelectedMasterPermissions, fetchAutoCode
    } = useContext(Context);
    //import from contexts


    useEffect(async () => {
        const authToken = localStorage.getItem("authToken")
        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var LocationName = obj[4]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
        var parentname = menuDetail?.parentName
        SetParentName(parentname)
        setLocationCode(LocationCode)
        setLocationName(LocationName)
        setLogUserType(LogUserType)
        setLogCompanyCode(CompanyCode)

        var responseData = await getSelectedMasterPermissions(LogUserType, menu)

        SetMenuAccess(responseData.strMenuAccessRight)
        SetMenuCreate(responseData.strMenuCreateRight)
        SetMenuDelete(responseData.strMenuDeleteRight)
        SetMenuModify(responseData.strMenuModifyRight)
        SetMenuPrint(responseData.strMenuPrintRight)
        SetMenuProcess(responseData.strMenuProcessRight)
        SetMenuName(responseData.strMenuName)
        SetMenuCode(responseData.strMenuTag)
        setPermissionReasonShow(responseData.strMenuReasonShow)


        fetchAutoCodeFromAPI(menu)

        const dropdownResponse = await GetSPDropdown(LogUserType)
        setSpDropdownList(dropdownResponse.data)

    }, [])


    // AuditLog
    useEffect(async () => {

        var obj = JSON.parse(localStorage.getItem("authUser"))
        var LogUserType = obj[2]
        var LocationCode = obj[3]
        var CompanyCode = obj[5]
        var menuDetail = await getMenuDetails(window.location.pathname)
        var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');

        await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log

    }, [])


    useEffect(async () => {


        if (selectedDropdown) {
            const getSelectedSpName = spDropdownList.find(sp => sp.value == selectedDropdown);

            const response = await GetSPStructure(getSelectedSpName.sp);

            setParameters(response.data);
            const initialFormValues = {};
            response.data.forEach(param => {
                if (param.mode == 'OUT') {

                    let defaultValue = param.dataType == 'numeric' || param.dataType == 'decimal' || param.dataType == 'int' ? 0 : param.dataType == 'date' || param.dataType == 'datetime' || param.dataType == 'time' ? moment().format('YYYY-MM-DD') : '';
                    initialFormValues[param.name] = defaultValue;

                } else {
                    initialFormValues[param.name] = '';
                }

            });
            setFormValues(initialFormValues);
        } else {
            setFormValues({})
        }

    }, [selectedDropdown])


    //save button function
    const handlesave = async (e) => {


        //copy form values to new object
        let formValuesCopy = { ...formValues };

        //assign default values to empty fields
        for (let i = 0; i < parameters.length; i++) {

            switch (parameters[i].dataType) {
                case 'numeric':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? parseFloat(0) : formValuesCopy[parameters[i].name];
                    break;
                case 'int':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? parseInt(0) : formValuesCopy[parameters[i].name];
                    break;
                case 'decimal':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? parseFloat(0) : formValuesCopy[parameters[i].name];
                    break;
                case 'date':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? '1900-01-01' : formValuesCopy[parameters[i].name];
                    break;
                case 'datetime':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? '1900-01-01' : formValuesCopy[parameters[i].name];
                    break;
                case 'time':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? '00:00:00' : formValuesCopy[parameters[i].name];
                    break;
                case 'bit':
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? false : formValuesCopy[parameters[i].name];
                    break;
                default:
                    formValuesCopy[parameters[i].name] = formValuesCopy[parameters[i].name] == "" ? '' : formValuesCopy[parameters[i].name];
                    break;
            }
        }


        const getSelectedSpName = spDropdownList.find(sp => sp.value == selectedDropdown);

        const jsonBody = {
            "ProcedureName": getSelectedSpName.sp,
            "Parameters": formValuesCopy,
            "LogLocation": LocationCode,
            "CreatedBy": LogUserType,
        }

        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Saving...")
            const response = await ExecuteSPStructure(jsonBody);

            if (response.success) {
                setAlertColor('success')
                setAlertMsg(response.message)
                setShow(true)
                ClearItem();
            } else {
                setAlertColor('danger')
                setAlertMsg(response.message)
                setShow(true)
            }

        } catch (error) {
            console.log(error)
        } finally {
            SetLoadingAlert(false)
            setTimeout(() => {
                setShow(false)
            }, time);
        }

    }



    //edit button function    
    const handleEdit = e => {

        setSaveEnable(true)
        SetDeleteEnable(true)
        SetEditEnable(false)
        setEditCheck(true)

    }

    //new button function
    const handleNew = e => {

        ClearItem();
        setShow(false)
        setSaveEnable(true)

    }

    //clear fields function    
    const ClearItem = () => {

        if (!keepSelectedSP) {
            SetAddNew(true)
            setErrorMsg('')
            SetDeleteEnable(false)
            setNullCode(false)
            setReason("Created")
            SetEditEnable(false)
            setSaveEnable(true)
            setPermissionName("")
            setPermissionPassword("")
            setPermissionNameDisable(false)
            setEditCheck(false)
            fetchAutoCode()
            setSelectedDropdown("")
            setFormValues({});
            setParameters([])
        } else {
            let formValuesCopy = { ...formValues };

            for (let i = 0; i < parameters.length; i++) {
                formValuesCopy[parameters[i].name] = '';
            }
            setFormValues(formValuesCopy);

        }



    }

    //********Delete button function */
    const handleDelete = () => {
    }


    async function handlePrint(option) {
    }

    const PermissionHandle = (operation) => {

        const authToken = localStorage.getItem("authToken")
        const permissiondata = {
            "strUsername": permissionName,
            "strPassword": permissionPassword,
            "strLocation": LocationCode,
            "strMenuCode": menuCode
        }

        setPermissionName("")
        setPermissionPassword("")
        setReason("")


        fetch(`${ApiURL}login/userpermission`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${authToken}`
                },
                body: JSON.stringify(permissiondata)
            }
        ).then(Response => {
            if (Response.status == "200") {
                Response.json()
                    .then(responseData => {
                        let Access = (responseData.data.strMenuAccessRight)
                        let Create = (responseData.data.strMenuCreateRight)
                        let Delete = (responseData.data.strMenuDeleteRight)
                        let Modify = (responseData.data.strMenuModifyRight)
                        let Print = (responseData.data.strMenuPrintRight)
                        let Process = (responseData.data.strMenuProcessRight)

                        if (operation == "Save") {
                            if (Create == true) {
                                handlesave()

                            } else if (Modify == true) {
                                handlesave()

                            } else {
                                if (operation == "Save" && addNew == true) {
                                    setAlertMsg("This user dosen't have permission to save")
                                    setAlertColor('danger')
                                    setShow(true)

                                } else {
                                    setAlertMsg("This user dosen't have permission to edit")
                                    setAlertColor('danger')
                                    setShow(true)

                                }
                            }
                        } else if (operation == "Delete") {
                            if (Delete == true) {
                                handleDelete()

                            } else {
                                setAlertColor('danger')
                                setAlertMsg("This user don't have permission to delete !")
                                setShow(true)

                            }
                        } else if (operation == "PDF") {
                            if (Print == true) {
                                handlePrint("PDF")

                            } else {
                                setAlertColor('danger')
                                setAlertMsg("This user don't have permission to print !")
                                setShow(true)

                            }
                        } else if (operation == "XCEL") {
                            if (Print == true) {
                                handlePrint("XCEL")

                            } else {
                                setAlertColor('danger')
                                setAlertMsg("This user don't have permission to print !")
                                setShow(true)
                            }
                        }
                    })

            } else if (Response.status == "400") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })


                setAlertColor('danger')
                setAlertMsg("Oops something went wrong !")
                setPermissionName("")
                setPermissionPassword("")
                setShow(true)

            } else if (Response.status == "403") {


                setAlertColor('danger')
                setAlertMsg("You have not Permission to make changes !")
                setPermissionName("")
                setPermissionPassword("")
                setShow(true)

            } else if (Response.status == "404") {
                Response.json()
                    .then(responseData => {
                        setErrorMsg(responseData.msg)
                    })
                setAlertColor('danger')
                setAlertMsg("Password or User Name is Invalid !")
                setPermissionName("")
                setPermissionPassword("")
                setShow(true)

            } else {
                ClearItem()
            }
        }).catch(error => {
            console.log(error.message)
        })

        setTimeout(() => {
            setShow(false)
        }, time)
    }


    async function fetchAutoCodeFromAPI(menu) {

        var autoCodeRes = await fetchAutoCode(menu)

        if (autoCodeRes.nullCode == false) {
            setAutoCode(autoCodeRes.autoCode)
        } else {
            setNullCode(true)
            setAutoCode("")
        }

    }


    const handleChange = (name, value) => {
        setFormValues({
            ...formValues,
            [name]: value
        });
    };


    return (
        < React.Fragment >
            <div className="page-content">
                <MetaTags>
                    <title>{menuName}</title>
                </MetaTags>
                <Container fluid={true}>
                    <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
                    <DPAlert
                        confirm_both={sweetAlertShow}
                        title={menuName}
                        description={AlertDescription}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        onConfirm={async () => {
                            setsweetAlertShow(false)
                            setPermissionName(LogUserType)
                            if (AlertConfirmOption == 1) {


                                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                                    handlesave()
                                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                                    handlesave()

                                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {

                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    if (addNew == false) {

                                    }
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }

                            } else if (AlertConfirmOption == 2) {
                                handleEdit()
                            } else if (AlertConfirmOption == 3) {
                                window.location.href = "/";
                            } else if (AlertConfirmOption == 4) {
                                handleNew()
                            } else if (AlertConfirmOption == 5) {

                                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                                    handleDelete()
                                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                                    setReason("")
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setReason("")
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            } else if (AlertConfirmOption == 6) {

                                if (menuPrint == true && permissionReasonShow == false) {
                                    setprintoptionShow(true)
                                } else if (menuPrint == true && permissionReasonShow == true) {
                                    setPermissionNameDisable(true)
                                    setPermissionAlertShow(true)
                                } else {
                                    setPermissionName("")
                                    setPermissionReasonShow(true)
                                    setPermissionAlertShow(true)
                                }
                            }

                        }}
                        onCancel={() => {
                            setsweetAlertShow(false)
                        }}
                    />
                    <DPPermission
                        confirm_both={permissionAlertShow}
                        title={menuName}
                        description={permissionAlertTitle}
                        showReason={permissionReasonShow}
                        nameDisable={false}//{permissionNameDisable}
                        showCancel={true}
                        btnColor={"success"}
                        cancelColor={"danger"}
                        AlName={permissionName}
                        show={permissionGrantedAlertShow}
                        AlertColor={permissionGrantedAlertColor}
                        AlertMsg={permissionGrantedAlertMsg}
                        AlNameOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", false)
                            setPermissionName(val2)
                        }}
                        AlPassward={permissionPassword}
                        AlPasswardOnchange={e => {
                            let val2 = Text(e.target, 50, true, true, "any", false)
                            setPermissionPassword(val2)
                        }}
                        AlReason={Reason}
                        AlReasonOnchange={e => {
                            let val2 = Text(e.target, 50, true, false, "any", true)
                            setReason(val2)
                        }}
                        onConfirm={() => {

                            setPermissionAlertShow(false)
                            if (AlertConfirmOption == 1) {
                                PermissionHandle("Save")
                            } else if (AlertConfirmOption == 5) {
                                PermissionHandle("Delete")
                            } else if (AlertConfirmOption == 6) {
                                setprintoptionShow(true)
                            }
                        }}
                        onCancel={() => {
                            setPermissionAlertShow(false)
                        }}
                    />
                    <DPPrintOption
                        confirm_both={printoptionShow}
                        title={menuName}
                        showCancel={true}
                        cancelColor={"danger"}
                        onConfirmpdf={() => {
                            handlePrint("PDF")
                            setprintoptionShow(false)
                        }}
                        onConfirmxcel={() => {
                            handlePrint("XCEL")
                            setprintoptionShow(false)
                        }}
                        onCancel={() => {
                            setprintoptionShow(false)
                        }}
                    />
                    <DPLoadingAlert
                        confirm_both={loadingAlert}
                        title={loadingAlertTitle}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <DPTopToolBar
                                        //Help Button
                                        helpEnable={false}
                                        helpClick={() => {
                                            alert("Help")
                                        }}
                                        //Favorite Button
                                        favoriteEnable={false}
                                        favoriteClick={() => {
                                            alert("Favorite")
                                        }}
                                        //New Button
                                        newEnable={true}
                                        newClick={() => {
                                            setAlertDescription("Do you wish to refresh the screen ?");
                                            setAlertConfirmOption(4)
                                            setsweetAlertShow(true)
                                        }}
                                        //Save Button
                                        saveEnable={saveEnable}
                                        saveClick={() => {
                                            setAlertDescription("Do you wish to save ?");
                                            setAlertConfirmOption(1)
                                            setsweetAlertShow(true)
                                        }}
                                        //ProcessButton
                                        processEnable={false}
                                        processClick={() => {
                                            alert("Process")
                                        }}
                                        //Edit Button
                                        editEnable={editEnable && isHeadOffice}
                                        editClick={() => {
                                            setAlertDescription("Do you wish to edit ?");
                                            setAlertConfirmOption(2)
                                            setsweetAlertShow(true)
                                        }}
                                        //Print Button

                                        printEnable={true}
                                        printClick={() => {
                                            setReason("Printed")
                                            setAlertDescription("Do you wish to print ?");
                                            setAlertConfirmOption(6)
                                            setsweetAlertShow(true)
                                        }}
                                        //Delete Button
                                        deleteEnable={deleteEnable}
                                        deleteClick={() => {
                                            setReason("Deleted")
                                            setAlertDescription("Do you wish to delete ?");
                                            setAlertConfirmOption(5)
                                            setsweetAlertShow(true)
                                        }}
                                        //Exit Button
                                        exitEnable={true}
                                        exitClick={() => {
                                            setAlertDescription("Do you wish to exit ?");
                                            setAlertConfirmOption(3)
                                            setsweetAlertShow(true)
                                        }}
                                    />
                                    <Row>
                                        {show ? (
                                            <Alert color={AlertColor} role="alert">
                                                {AlertMsg}
                                                <br />
                                                <small>{ErrorMsg}</small>
                                            </Alert>
                                        ) : null}
                                    </Row>
                                    <Row>
                                        <DynamicUIFromSPContent
                                            formValues={formValues}
                                            handleChange={handleChange}
                                            parameters={parameters}
                                            spDropdownList={spDropdownList}
                                            selectedDropdown={selectedDropdown}
                                            setSelectedDropdownOnChange={(e) => {
                                                setSelectedDropdown(e["value"])
                                            }}
                                            keepSelectedSP={keepSelectedSP}
                                            setKeepSelectedSP={setKeepSelectedSP}
                                        />
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment >
    )

}

export default DynamicUIFromSP

